import { Box, CircularProgress, Typography } from '@mui/material'
import { t } from '../i18n'

/**
 * ADR-0024 D9.4 - padrao unico de carregamento.
 * Proibido spinner improvisado por tela.
 */
export function LoadingState({ label }: { label?: string }) {
  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{ display: 'flex', alignItems: 'center', gap: 2, py: 4 }}
    >
      <CircularProgress size={24} />
      <Typography variant="body2" color="text.secondary">
        {label ?? t.common.loading}
      </Typography>
    </Box>
  )
}
